import { render, staticRenderFns } from "./sglMain.vue?vue&type=template&id=f9fa780c&scoped=true&"
import script from "./sglMain.vue?vue&type=script&lang=js&"
export * from "./sglMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fa780c",
  null
  
)

export default component.exports